import { render, staticRenderFns } from "./EditBarLabelPage.vue?vue&type=template&id=fbd5dc16&scoped=true&"
import script from "./EditBarLabelPage.vue?vue&type=script&lang=js&"
export * from "./EditBarLabelPage.vue?vue&type=script&lang=js&"
import style0 from "./EditBarLabelPage.vue?vue&type=style&index=0&id=fbd5dc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd5dc16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VRadio,VRadioGroup,VTextField})
